<template>
    <component
        :is="certainComponent"
        :to="isLink ? urlPath : null"
        :href="isLink ? urlPath : null"
        :class="{
            'ui-action-btn': true,
            '--dark': isDarkTheme,
            '--transparent': isTransparentTheme,
            '--transparent-light': isTransparentLightTheme,
            '--light': isLightTheme,
            '--only-text': isTypeText,
            '--only-icon': isTypeIcon,
            '--transparent-border': isTransparentBorderTheme,
            '--size-medium': isSizeMedium,
            '--size-small': isSizeSmall,
            '--size-tiny': isSizeTiny,
            '--fit-content': !isFreeWidth,
            disabled: disabled
        }"
        :type="btnType"
        :disabled="disabled"
        :title="isLink ? urlPath : btnText"
        @click="$emit('click')"
    >
        <div :class="{ 'ui-action-btn__container': true, '--reverse': isReversContent }">
            <slot />
            <div v-if="isTypeText || isDefaultType" class="ui-action-btn__container__text">
                <span>{{ btnText }}</span>
            </div>
            <div v-if="isTypeIcon || isDefaultType" class="ui-action-btn__container__icon">
                <svg><use :xlink:href="iconLink"></use></svg>
            </div>
        </div>
    </component>
</template>

<script>
import VueTypes, { nullable } from 'vue-types';
import { allowedIconsIds, themes, types, sizes, defaultIcon, defaultTheme, defaultType, defaultSize } from './types.js';

export default {
    name: 'MyActionBtn',
    props: {
        btnText: VueTypes.oneOfType([String, nullable]).def(null),
        btnType: VueTypes.string.def('button'),

        icon: VueTypes.oneOf(allowedIconsIds).def(defaultIcon),
        theme: VueTypes.oneOf(themes).def(defaultTheme),
        type: VueTypes.oneOf(types).def(defaultType),
        size: VueTypes.oneOf(sizes).def(defaultSize),

        disabled: VueTypes.bool.def(false),
        isFreeWidth: VueTypes.bool.def(false),
        urlPath: VueTypes.oneOfType([String, nullable]).def(null),
        isNuxtLink: VueTypes.bool.def(false),
        isReversContent: VueTypes.bool.def(false)
    },
    computed: {
        isDarkTheme() {
            return this.theme === 'dark' ? true : false;
        },
        isTransparentBorderTheme() {
            return this.theme === 'transparent-border' ? true : false;
        },
        isTransparentTheme() {
            return this.theme === 'transparent' ? true : false;
        },
        isTransparentLightTheme() {
            return this.theme === 'transparent-light' ? true : false;
        },
        isLightTheme() {
            return this.theme === 'light' ? true : false;
        },
        isDefaultType() {
            return this.type === 'default' ? true : false;
        },
        isTypeText() {
            return this.type === 'text' ? true : false;
        },
        isTypeIcon() {
            return this.type === 'icon' ? true : false;
        },
        isSizeMedium() {
            return this.size === 'medium' ? true : false;
        },
        isSizeSmall() {
            return this.size === 'small' ? true : false;
        },
        isSizeTiny() {
            return this.size === 'tiny' ? true : false;
        },
        certainComponent() {
            if (this.urlPath === null) {
                return 'button';
            }
            if (this.isNuxtLink) {
                return 'NuxtLink';
            }
            return 'a';
        },
        isLink() {
            return this.certainComponent === 'NuxtLink' || this.certainComponent === 'a' ? true : false;
        },
        iconLink() {
            const spritePath = require('@/themes/ecaterix/assets/icons/sprite.svg');
            return `${spritePath}#${this.icon}`;
        }
    }
};
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
